/**
 * Represents a div.btn-group of one button with a dropdown.
 */

import Backbone from "backbone";
import Marionette from "backbone.marionette";
import FilterOptions from "./filter-options";
import GroupByOptions from "./groupby-options";
import DatePickerBehavior from "../../../behaviors/kendo-ui/datepicker";
import RangeSliderBehavior from "../../../behaviors/kendo-ui/range-slider";
import NumericRangeBehavior from "../../../behaviors/kendo-ui/numeric-range";
import ChosenBehavior from "../../../behaviors/chosen";
import InputClear from "../../../behaviors/input-clear";
import templates from "../../../utils/templates";

const CONTAINER = ".dropdown-menu";
const EVENT_DROPDOWN_SHOWN = "shown.bs.dropdown";
const DEFAULTS = {
  className: "btn-group",
  template: templates.find("layout", "dropdown_button"),
};

const Model = Backbone.Model.extend();

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  events() {
    return {
      EVENT_DROPDOWN_SHOWN: "_onDropdownShown",
    };
  }

  behaviors() {
    return [
      { behaviorClass: DatePickerBehavior },
      { behaviorClass: RangeSliderBehavior },
      { behaviorClass: NumericRangeBehavior },
      { behaviorClass: ChosenBehavior },
      { behaviorClass: InputClear },
    ];
  }

  onBeforeShow() {
    const target = this.$(CONTAINER);

    // is there data to show?
    if (this.model.has("data")) {
      // create and attach view
      let view = null;
      const modelData = this.model.get("data");

      switch (this.model.get("action")) {
        case "filters":
          // create filter options view
          view = new FilterOptions({
            model: new Model(modelData.data),
          });

          break;

        case "group-by":
          // create group-by options view
          view = new GroupByOptions(modelData);

          break;
      }

      // render view and prepend it to container element
      if (view) {
        view.render().$el.prependTo(target);
      }
    } else {
      // disable button
      this.$("button").addClass("disabled");
    }
  }

  _onDropdownShown() {
    // remove listener
    this.$el.off(EVENT_DROPDOWN_SHOWN);
  }
}

export { View as default };
